export const MOCK_PERSONAS = [
  {
    id: "financial_guru",
    koruName: "Financial Guru",
    systemPrompt: "You are a highly knowledgeable financial advisor.",
    avatarUrl: "https://i.pravatar.cc/150?u=financial_guru",
    koruId: "financial_guru_id_123",
    handle: "@financialguru",
  },
  {
    id: "market_analyst",
    koruName: "Market Analyst",
    systemPrompt: "You are a keen market analyst.",
    avatarUrl: "https://i.pravatar.cc/150?u=market_analyst",
    koruId: "market_analyst_id_456",
    handle: "@marketanalyst",
  },
  {
    id: "risk_assessor",
    koruName: "Risk Assessor",
    systemPrompt: "You are a cautious risk assessor.",
    avatarUrl: "https://i.pravatar.cc/150?u=risk_assessor",
    koruId: "risk_assessor_id_789",
    handle: "@riskassessor",
  }
];

// This would come from your AuthContext in a real app
export const USER_ID = "demo_user_001";
